/**
 * Traductions Português (Brésilien) pour le dictionnaire Strong
 * PT translations for Strong's Dictionary
 * Généré automatiquement via Ollama + Qwen 2.5 14B
 * 
 * Structure: { m: meaning, d: definition, u: usage, e: etymology }
 */

export const strongTranslationsPT = {
  "G25": {
    "m": "amar com um amor divino e desinteressado",
    "d": "Amor perfeito de Deus; amor fraterno, afeto, boa vontade, caridade. O amor que une Deus e o homem, e o homem ao seu próximo.",
    "u": "O amor divino e incondicional manifestado por Deus para a humanidade e o amor que devemos ter uns pelos outros conforme ensinado na Bíblia.",
    "e": "Deriva do grego 'agapé', expressando um sentimento de amor desinteressado, sacrificial e divino."
  },
  "G26": {
    "m": "amor divino, caridade",
    "d": "Amor perfeito de Deus; amor fraterno, afeto, boa vontade, caridade. O amor que une Deus e o homem, e o homem ao seu próximo.",
    "u": "A manifestação do amor divino na vida humana, caracterizado por sacrifício e desinteresse próprio.",
    "e": "Deriva do grego 'agapé', expressando um sentimento de amor perfeito e incondicional."
  },
  "G4102": {
    "m": "fé, confiança, fidelidade",
    "d": "Convicção da verdade de qualquer coisa; crença. No NT, refere-se à convicção sobre a relação do homem com Deus e as coisas divinas.",
    "u": "A fé bíblica é uma confiança inabalável na promessa e na presença de Deus em todas as circunstâncias da vida.",
    "e": "Deriva do grego 'pistis', significando convicção ou crença."
  },
  "G1680": {
    "m": "esperança, confiança esperançosa",
    "d": "Esperança em coisas boas; esperança baseada na promessa divina. Confiança no futuro fundamentada nas promessas de Deus.",
    "u": "A esperança bíblica é uma certeza espiritual e confiante que se baseia nas promessas eternas de Deus.",
    "e": "Deriva do grego 'elpis', significando a expectativa firme e confiante."
  },
  "G5281": {
    "m": "paciência, resistência",
    "d": "Qualidade de quem não se rende às circunstâncias ou pressões; paciência constante e persistente.",
    "u": "A qualidade bíblica de perseverar em face das dificuldades e adversidades, mantendo-se firme na fé.",
    "e": "Deriva do grego 'hupomone', significando resistir ou suportar."
  },
"G5544": {
    "m": "bondade, benevolência",
    "d": "Bondade em ação, benevolência prática; qualidade de quem é útil e benéfico aos outros.",
    "u": "Usado 10 vezes no NT. Fruto do Espírito conforme Gálatas 5:22.",
    "e": "De χρηστός (chrestos) = bom, útil, benevolente"
  },
  "G2205": {
    "m": "zeladoria, ciúme, inveja",
    "d": "Calor apaixonado; pode ser positivo (zeladoria por Deus) ou negativo (ciúme, inveja).",
    "u": "Usado 16 vezes no NT. Pode ser virtuoso ou vicioso de acordo com o contexto.",
    "e": "De ζέω (zeo) = ferver, estar fervoroso"
  },
  "G166": {
    "m": "eterno, perpétuo",
    "d": "Sem começo nem fim, que existe sempre; no NT, frequentemente associado à vida eterna em Deus.",
    "u": "Usado 71 vezes no NT. Geralmente qualifica a vida eterna e o reino de Deus.",
    "e": "De αἰών (aion) = idade, época, eternidade"
  },
  "G2316": {
    "m": "Deus, divindade",
    "d": "O Ser Supremo, Deus Pai, Jesus Cristo, o Espírito Santo; às vezes usado para falsas divindades.",
    "u": "Usado 1317 vezes no NT. A palavra central para designar Deus.",
    "e": "Origem incerta, possivelmente de θέω (theo) = correr, ou de τίθημι (tithemi) = colocar"
  },
  "G1097": {
    "m": "conhecer, saber, compreender",
    "d": "Conhecer por experiência pessoal; entender, perceber, ser consciente de.",
    "u": "Usado 222 vezes no NT. Conhecimento experiencial, não apenas intelectual.",
    "e": "Raiz indo-europeia *gen- = gerar, conhecer"
  },
  "G2889": {
    "m": "mundo, universo, humanidade",
    "d": "A ordem do mundo, o universo; a humanidade caída; o sistema oposto a Deus.",
    "u": "Usado 186 vezes no NT. Pode se referir à criação ou ao sistema pecador.",
    "e": "De κοσμέω (kosmeo) = ornar, arranjar"
  },
  "G5207": {
    "m": "filho",
    "d": "Descendente masculino; discípulo; membro de um grupo. O Filho de Deus = Jesus Cristo.",
    "u": "Usado 377 vezes no NT. Frequentemente para designar Jesus como o Filho de Deus.",
    "e": "Origem incerta, pode estar relacionado a ὕω (huo) = fazer chover, gerar"
  },
  "G4151": {
    "m": "espírito, sopro, vento",
    "d": "O sopro da vida, o princípio vital; a alma racional; o Espírito Santo.",
    "u": "Usado 385 vezes no NT. Designa o Espírito Santo, o espírito humano ou espíritos.",
    "e": "De πνέω (pneo) = soprar, respirar"
  },
  "G225": {
    "m": "verdade, realidade",
    "d": "O que é verdadeiro em relação às coisas concernant a Deus e os deveres do homem; a verdade divina revelada.",
    "u": "Usado 109 vezes no NT. Conceito central no ensino de Jesus.",
    "e": "De ἀληθής (alethes) = verdadeiro, sincero"
  },
  "G93": {
    "m": "injustiça, iniquidade",
    "d": "Violação do direito, injustiça; maldade, iniquidade moral.",
    "u": "Usado 25 vezes no NT. Contrário de δικαιοσύνη (justiça).",
    "e": "De ἀ- (negação) + δίκη (dike) = justiça"
  },
  "G5463": {
    "m": "alegrar-se, ser feliz",
    "d": "Alegrar-se, ser feliz ; saudação 'alegra-te' ou 'olá'.",
    "u": "Usado 74 vezes no NT. Pedido frequente para se alegrarem em Cristo.",
    "e": "Relacionado a χάρις (charis) = graça"
  },
  "G4648": {
    "m": "olhar atentamente, mirar",
    "d": "Fixar os olhos em algo, considerar atentamente ; ter como alvo, mirar um objetivo.",
    "u": "Usado 6 vezes no NT. Chamada para fixar os olhos em Cristo.",
    "e": "Relacionado a σκοπός (skopos) = alvo, objetivo"
  },
  "G2596": {
    "m": "conforme, contra, através de",
    "d": "Preposição com vários sentidos : conforme, em conformidade com ; contra ; através de.",
    "u": "Usado mais de 470 vezes no NT. Preposição muito frequente.",
    "e": "Preposição primária"
  },
  "G3609": {
    "m": "doméstico, da casa",
    "d": "Pertencente à casa, membro da família ; servo doméstico.",
    "u": "Usado 3 vezes no NT. Descreve os membros da família de Deus.",
    "e": "De οἶκος (oikos) = casa"
  },
  "G1325": {
    "m": "dar, conceder",
    "d": "Dar algo a alguém ; conceder, permitir ; entregar.",
    "u": "Usado 415 vezes no NT. Deus dá generosamente.",
    "e": "Raiz primária"
  },
  "G1785": {
    "m": "comando, ordem",
    "d": "Um comando, ordem, preceito ; especialmente um comando divino.",
    "u": "Utilizado 67 vezes no NT. Os comandos de Deus e de Cristo.",
    "e": "De ἐντέλλομαι (entellomai) = dar um comando"
  },
  "G2537": {
    "m": "novo, recente",
    "d": "Novo no tempo ou na qualidade ; fresco, recente, não usado.",
    "u": "Utilizado 42 vezes no NT. Nova criação, novo comando.",
    "e": "Raiz incerta"
  },
  "G3101": {
    "m": "discípulo, aluno",
    "d": "Um aprendiz, estudante, discípulo ; seguidor de Jesus.",
    "u": "Utilizado 261 vezes no NT. Designa os seguidores de Cristo.",
    "e": "De μανθάνω (manthano) = aprender"
  },
  "G2588": {
    "m": "coração",
    "d": "O coração físico ; o centro da vida interior, a alma, o espírito ; os pensamentos e sentimentos.",
    "u": "Utilizado 156 vezes no NT. Sede da vida espiritual.",
    "e": "Raiz primária"
  },
  "G5590": {
    "m": "alma, vida",
    "d": "O sopro de vida, a alma vital ; a própria vida ; a alma imortal.",
    "u": "Utilizado 105 vezes no NT. A vida espiritual e eterna.",
    "e": "De ψύχω (psucho) = respirar, refrescar"
  },
  "G1271": {
    "m": "inteligência, pensamento",
    "d": "A faculdade de pensar, entender e compreender; o espírito, a compreensão.",
    "u": "Usado 12 vezes no NT. O espírito renovado por Cristo.",
    "e": "De διά (dia) = através + νοῦς (nous) = espírito"
  },
  "G4413": {
    "m": "primeiro, principal",
    "d": "Primeiro no tempo, lugar, ordem ou importância.",
    "u": "Usado 155 vezes no NT. O primeiro mandamento, a primeira posição.",
    "e": "Superlativo de πρό (pro) = antes"
  },
  "G3173": {
    "m": "grande, importante",
    "d": "Grande em tamanho, quantidade ou importância; poderoso, maravilhoso.",
    "u": "Usado 243 vezes no NT. A grandeza de Deus.",
    "e": "Raiz primária"
  },
  "G1208": {
    "m": "segundo",
    "d": "O segundo em uma série ou ordem.",
    "u": "Usado 44 vezes no NT. O segundo mandamento.",
    "e": "De δύο (duo) = dois"
  },
  "G3664": {
    "m": "semelhante, igual",
    "d": "Semelhante, da mesma natureza ou caráter; equivalente.",
    "u": "Usado 45 vezes no NT. O segundo mandamento semelhante ao primeiro.",
    "e": "De ὁμός (homos) = mesmo"
  },
  "G4139": {
    "m": "próximo, vizinho",
    "d": "Aquele que está próximo, o vizinho; o próximo em geral.",
    "u": "Utilizado 17 vezes no NT. 'Amor ao próximo como a si mesmo'.",
    "e": "Adverbio tornado nome, de πλησίος (plesios) = perto"
  },
  "G1473": {
    "m": "eu, mim",
    "d": "Pronome pessoal da primeira pessoa do singular.",
    "u": "Utilizado 2567 vezes no NT. Muito frequente.",
    "e": "Pronome primário"
  },
  "G3962": {
    "m": "pai",
    "d": "Um pai natural ou espiritual; ancestral; Deus o Pai.",
    "u": "Utilizado 413 vezes no NT. Frequentemente para designar Deus.",
    "e": "Raiz primária aparentada ao latim 'pater'"
  },
  "G1520": {
    "m": "um, único",
    "d": "Um só; único, apenas; um certo.",
    "u": "Utilizado 344 vezes no NT. A unidade de Deus, a igreja unida.",
    "e": "Raiz primária"
  },
  "G3708": {
    "m": "ver, olhar",
    "d": "Ver com os olhos; perceber, compreender; aparecer.",
    "u": "Utilizado 454 vezes no NT. Ver Cristo, ver o Pai.",
    "e": "Raiz primária"
  },
  "G1166": {
    "m": "mostrar, demonstrar",
    "d": "Expor aos olhos, mostrar ; provar, demonstrar.",
    "u": "Usado 33 vezes no NT. Deus mostra sua glória.",
    "e": "Raiz primária"
  },
  "G281": {
    "m": "amém, verdadeiramente",
    "d": "Fórmula de afirmação : assim seja, verdadeiramente, certamente.",
    "u": "Usado 129 vezes no NT. Jesus diz 'Verdadeiramente, verdadeiramente'.",
    "e": "Do hebraico אָמֵן (amen) = firme, fiel"
  },
  "G1510": {
    "m": "ser, existir",
    "d": "Verbo ser em todos os seus sentidos ; existir, permanecer, ocorrer.",
    "u": "O verbo mais usado no NT (2460+ vezes).",
    "e": "Raiz primária"
  },
  "G11": {
    "m": "Abraão",
    "d": "O patriarca Abraão, pai dos crentes.",
    "u": "Usado 73 vezes no NT. Modelo de fé.",
    "e": "Do hebraico אַבְרָהָם (Abraham) = pai de uma multidão"
  },
  "G3598": {
    "m": "caminho, via",
    "d": "Trilha, caminho ; modo de vida, conduta ; o caminho do salvação.",
    "u": "Usado 101 vezes no NT. Jesus é o caminho.",
    "e": "Raiz primária"
  },
  "G4166": {
    "m": "pastor",
    "d": "Aquele que guarda as ovelhas; guardião espiritual, pastor da igreja.",
    "u": "Usado 18 vezes no NT. Jesus, o bom pastor.",
    "e": "De ποίμνη (poimne) = rebanho"
  },
  "G2570": {
    "m": "bom, belo",
    "d": "Bom em sua natureza, belo; honroso, excelente, virtuoso.",
    "u": "Usado 100 vezes no NT. O bom pastor, as boas obras.",
    "e": "Raiz primária"
  },
  "G5087": {
    "m": "colocar, pôr, estabelecer",
    "d": "Colocar, pôr; estabelecer, nomear; depositar, colocar.",
    "u": "Usado 100 vezes no NT. Colocar sua vida pelas ovelhas.",
    "e": "Raiz primária"
  },
  "G4263": {
    "m": "ovelha, carneiro",
    "d": "Ovelha ou carneiro; metaforicamente, os discípulos de Cristo.",
    "u": "Usado 39 vezes no NT. Os crentes como ovelhas do pastor.",
    "e": "Provavelmente ligado a προβαίνω (probaino) = avançar"
  },
  "G740": {
    "m": "pão",
    "d": "Pão, alimento; o pão da vida = Cristo.",
    "u": "Usado 97 vezes no NT. Jesus, o pão da vida.",
    "e": "De ἄρω (aro) = levantar, erguer"
  },
  "G3756": {
    "m": "não... não, não",
    "d": "Negação absoluta, não, não.",
    "u": "Utilizado mais de 1600 vezes no NT. Partícula de negação muito frequente.",
    "e": "Partícula primária de negação"
  },
  "G1372": {
    "m": "ter sede, desejar ardorosamente",
    "d": "Sofrer de sede ; desejar ardorosamente, aspirar a.",
    "u": "Utilizado 16 vezes no NT. Sede espiritual de Deus.",
    "e": "De δίψα (dipsa) = sede"
  },
  "G1411": {
    "m": "poder, força, milagre",
    "d": "Força, poder, capacidade ; ato de poder, milagre.",
    "u": "Utilizado 120 vezes no NT. O poder de Deus, do Espírito Santo.",
    "e": "De δύναμαι (dunamai) = ser capaz"
  },
  "G1743": {
    "m": "fortalecer, tornar forte",
    "d": "Tornar forte, fortificar ; dar poder.",
    "u": "Utilizado 8 vezes no NT. Deus fortifica os crentes.",
    "e": "De ἐν (en) = em + δυναμόω (dynamoo) = tornar poderoso"
  },
  "G1515": {
    "m": "paz",
    "d": "Estado de tranquilidade ; paz com Deus ; harmonia entre as pessoas.",
    "u": "Utilizado 92 vezes no NT. A paz de Cristo.",
    "e": "De εἴρω (eiro) = unir, ligar"
  },
  "G5432": {
    "m": "guardar, proteger",
    "d": "Manter com uma guarda militar ; proteger, preservar.",
    "u": "Utilizado 4 vezes no NT. A paz de Deus guarda nossos corações.",
    "e": "De φρουρός (phrouros) = guarda, sentinela"
  },
  "G5457": {
    "m": "luz",
    "d": "Luz física ou espiritual ; a verdade divina revelada.",
    "u": "Utilizado 73 vezes no NT. Jesus luz do mundo.",
    "e": "De φάω (phao) = brilhar"
  },
  "G27": {
    "m": "querido, amado",
    "d": "Amar, querer ; amado de Deus ou dos homens.",
    "u": "Utilizado 61 vezes no NT. O Filho amado de Deus.",
    "e": "De ἀγαπάω (agapao) = amar"
  },
  "G1080": {
    "m": "gerar, dar à luz",
    "d": "Gerar, dar à luz ; nascer novamente espiritualmente.",
    "u": "Utilizado 97 vezes no NT. Nascer de Deus, ser nascido de novo.",
    "e": "Raiz primária"
  },
  "G3474": {
    "m": "loucura, tolice",
    "d": "Loucura, absurdez ; o que falta em sabedoria.",
    "u": "Utilizado 5 vezes no NT. A sabedoria de Deus parece loucura ao mundo.",
    "e": "De μωρός (moros) = tolo, insensato"
  },
  "G4680": {
    "m": "sábio, erudito",
    "d": "Sábio, inteligente, habilidoso ; educado, instruído.",
    "u": "Utilizado 22 vezes no NT. A verdadeira sabedoria vem de Deus.",
    "e": "Raiz primária"
  },
  "G444": {
    "m": "homem, ser humano",
    "d": "Ser humano, homem ou mulher ; a humanidade em geral.",
    "u": "Utilizado 550 vezes no NT. O homem criado à imagem de Deus.",
    "e": "De ἀνήρ (aner) = homem e ὤψ (ops) = rosto"
  },
  "G772": {
    "m": "fraco, doente",
    "d": "Sem força, fraco ; doente, enfermo ; espiritualmente fraco.",
    "u": "Utilizado 25 vezes no NT. Deus escolhe os fracos do mundo.",
    "e": "De ἀ- (negação) + σθένος (sthenos) = força"
  },
  "G1586": {
    "m": "escolher, eleger",
    "d": "Escolher para si mesmo, selecionar ; eleger por graça divina.",
    "u": "Utilizado 21 vezes no NT. Deus elege seus filhos.",
    "e": "De ἐκ (ek) = fora de + λέγω (lego) = escolher"
  },
  "G2617": {
    "m": "envergonhar, desonrar",
    "d": "Envergonhar, desonrar ; confundir, humilhar.",
    "u": "Utilizado 13 vezes no NT. Deus confunde os sábios do mundo.",
    "e": "De κατά (kata) = contra + αἰσχύνω (aischuno) = ter vergonha"
  },
  "G36": {
    "m": "de origem humilde, desprezível",
    "d": "Sem nobreza, de origem humilde ; desprezado.",
    "u": "Usado 1 vez no NT (1 Cor 1:28).",
    "e": "De ἀ- (negação) + γένος (genos) = nascimento"
  },
  "G1848": {
    "m": "desprezar, tratar com desprezo",
    "d": "Considerar como nada, desprezar ; tratar com desdém.",
    "u": "Usado 11 vezes no NT. O mundo despreza o que Deus escolhe.",
    "e": "De ἐξ (ex) = fora de + οὐθείς (outheis) = ninguém"
  },
  "G4561": {
    "m": "carne, corpo",
    "d": "Carne, carne ; o corpo humano ; a natureza humana caída.",
    "u": "Usado 147 vezes no NT. Contraste entre carne e espírito.",
    "e": "Raiz primária"
  },
  "G2744": {
    "m": "gloriar-se, vangloriar-se",
    "d": "Gloriar-se, vangloriar-se ; encontrar sua alegria em algo.",
    "u": "Usado 37 vezes no NT. Gloriar-se no Senhor.",
    "e": "De καῦχος (kauchos) = vanglória"
  },
  "G5040": {
    "m": "pequeno, criança",
    "d": "Pequeno, criança ; termo carinhoso para discípulo.",
    "u": "Usado 8 vezes no NT. João chama seus leitores de 'pequenos'.",
    "e": "Diminutivo de τέκνον (teknon) = filho"
  },
  "G3056": {
    "m": "palavra, palavra, razão",
    "d": "Palavra pronunciada ; razão, inteligência ; o Logos = Cristo.",
    "u": "Usado 330 vezes no NT. O Logos encarnado.",
    "e": "De λέγω (lego) = dizer"
  },
  "G1100": {
    "m": "língua, linguagem",
    "d": "Órgão da palavra ; linguagem, dialeto ; dom de línguas.",
    "u": "Usado 50 vezes no NT. O dom de línguas.",
    "e": "Raiz primária"
  },
  "G2041": {
    "m": "obra, trabalho, ato",
    "d": "Trabalho, labor ; ação, ato ; obra realizada.",
    "u": "Usado 169 vezes no NT. As obras de Deus, as boas obras.",
    "e": "De ἔργω (ergo) = trabalhar"
  },
  "G3793": {
    "m": "multidão, multidão",
    "d": "Multidão de pessoas, multidão ; a massa popular.",
    "u": "Usado 175 vezes no NT. As multidões que seguiam Jesus.",
    "e": "De ὄχος (ochos) = veículo (que transporta)"
  },
  "G1484": {
    "m": "nação, povo, gentios",
    "d": "Povo, nação ; as nações gentílicas (não-judeus).",
    "u": "Usado 162 vezes no NT. O evangelho para todas as nações.",
    "e": "Raiz primária"
  },
  "G5443": {
    "m": "tribo, povo",
    "d": "Tribu, clã ; um povo descendente de um ancestral comum.",
    "u": "Usado 31 vezes no NT. As doze tribos de Israel.",
    "e": "De φύω (phuo) = produzir, fazer crescer"
  },
  "G2992": {
    "m": "povo",
    "d": "Um povo, uma nação ; especialmente o povo de Deus (Israel ou a Igreja).",
    "u": "Usado 142 vezes no NT. O povo eleito de Deus.",
    "e": "Raiz primária"
  },
  "G2362": {
    "m": "trono",
    "d": "Trono real, trono ; poder e autoridade real.",
    "u": "Usado 62 vezes no NT. O trono de Deus e do Cordeiro.",
    "e": "Raiz primária"
  },
  "G721": {
    "m": "cordeiro",
    "d": "Pequeno cordeiro ; designa Jesus Cristo como o Cordeiro de Deus.",
    "u": "Usado 30 vezes no NT, principalmente na Apocalipse.",
    "e": "Diminutivo de ἀρήν (aren) = cordeiro"
  },
  "G3022": {
    "m": "branco, brilhante",
    "d": "Branco, reluzente ; símbolo de pureza e vitória.",
    "u": "Usado 25 vezes no NT. As vestes brancas dos redimidos.",
    "e": "De λευκός (leukos) = branco, luminoso"
  },
  "G5495": {
    "m": "mão",
    "d": "A mão ; poder, autoridade ; ação, obra.",
    "u": "Usado 177 vezes no NT. A mão de Deus, as mãos de Jesus.",
    "e": "Raiz primária"
  },
  "G2424": {
    "m": "Jesus",
    "d": "Jesus de Nazaré, o Messias, o Salvador.",
    "u": "Usado 917 vezes no NT. O nome acima de todo nome.",
    "e": "Do hebraico יְהוֹשֻׁעַ (Yehoshua) = YHWH salva"
  },
  "G5547": {
    "m": "Cristo, Messias, Ungido",
    "d": "O Ungido, o Messias ; título de Jesus como Salvador prometido.",
    "u": "Usado 529 vezes no NT. Jesus é o Cristo.",
    "e": "De χρίω (chrio) = ungir"
  },
  "G907": {
    "m": "batizar, imergir",
    "d": "Imergir na água ; batizar para purificar ou iniciar.",
    "u": "Usado 77 vezes no NT. O batismo cristão.",
    "e": "De βάπτω (bapto) = mergulhar, imergir"
  },
  "G1746": {
    "m": "vestir-se, revestir",
    "d": "Pôr uma roupa ; revestir de uma qualidade ou poder.",
    "u": "Usado 27 vezes no NT. Revestir Cristo, vestir a armadura de Deus.",
    "e": "De ἐν (en) = em + δύω (duo) = entrar, vestir"
  },
  "G2453": {
    "m": "Judeu, Judeu",
    "d": "Pertencente à raça judaica ; habitante da Judéia.",
    "u": "Utilizado 195 vezes no NT. Os judeus, povo eleito de Deus.",
    "e": "De Ἰούδας (Ioudas) = Juda"
  },
  "G1672": {
    "m": "Grego, Gentio",
    "d": "Um Grego por nascimento ou língua ; um não-judeu.",
    "u": "Utilizado 25 vezes no NT. Nem judeu nem grego em Cristo.",
    "e": "De Ἑλλάς (Hellas) = Grécia"
  },
  "G1401": {
    "m": "escravo, servo",
    "d": "Escravo, servo ; servo de Deus voluntário.",
    "u": "Utilizado 124 vezes no NT. Servos de Cristo.",
    "e": "De δέω (deo) = ligar"
  },
  "G1658": {
    "m": "livre, libertado",
    "d": "Livre, não escravo ; libertado do jugo do pecado.",
    "u": "Utilizado 23 vezes no NT. Libertos em Cristo.",
    "e": "Provavelmente de ἔρχομαι (erchomai) = vir"
  },
  "G730": {
    "m": "masculino, macho",
    "d": "Do sexo masculino, macho.",
    "u": "Utilizado 9 vezes no NT. Deus criou o homem macho e fêmea.",
    "e": "Raiz primária"
  },
  "G2338": {
    "m": "fêmea, feminino",
    "d": "Do sexo feminino, fêmea.",
    "u": "Utilizado 5 vezes no NT. Homem e mulher iguais em Cristo.",
    "e": "De θηλάζω (thelazo) = amamentar"
  },
  "G1417": {
    "m": "dois",
    "d": "O número dois ; uma par.",
    "u": "Utilizado 135 vezes no NT. Dois ou três testemunhas.",
    "e": "Raiz primária"
  },
  "G5109": {
    "m": "parede",
    "d": "Parede de separação, parede divisória.",
    "u": "Utilizado 1 vez no NT (Atos 23:3).",
    "e": "Raiz primária"
  },
  "G3320": {
    "m": "parede de separação",
    "d": "Parede divisória, parede de separação.",
    "u": "Utilizado 1 vez no NT (Efésios 2:14). A parede entre judeus e gentios.",
    "e": "De μέσος (mesos) = meio + τοῖχος (toichos) = parede"
  },
  "G2189": {
    "m": "inimizade, hostilidade",
    "d": "Ódio, inimizade, hostilidade.",
    "u": "Utilizado 6 vezes no NT. A inimizade com Deus abolida.",
    "e": "De ἐχθρός (echthros) = inimigo"
  },
  "H7225": {
    "m": "início, primícias",
    "d": "Início, começo ; o melhor, as primícias.",
    "u": "Utilizado 51 vezes na AT. No princípio Deus criou...",
    "e": "De רֹאשׁ (rosh) = cabeça, início"
  },
  "H7462": {
    "m": "pastorear, pastor, alimentar",
    "d": "Pastorear um rebanho ; ser pastor ; alimentar, cuidar.",
    "u": "Utilizado 173 vezes na AT. O Senhor é meu pastor.",
    "e": "Raiz primitiva"
  },
  "H2637": {
    "m": "faltar, precisar",
    "d": "Faltar de, precisar ; diminuir, faltar.",
    "u": "Utilizado 23 vezes na AT. Eu não faltarei de nada (Sl 23:1).",
    "e": "Raiz primitiva"
  },
  "H5216": {
    "m": "pasto, terra cultivada",
    "d": "Praia, pasto ; terra cultivada, campo.",
    "u": "Utilizado 2 vezes na AT. Pastos verdejantes.",
    "e": "De נִיר (niyr) = laborar"
  },
  "H216": {
    "m": "luz",
    "d": "Luz natural ou espiritual ; felicidade, prosperidade.",
    "u": "Utilizado 120 vezes na AT. Que haja luz !",
    "e": "De אוֹר (or) = ser luminoso"
  },
  "H982": {
    "m": "confiar-se, ter confiança",
    "d": "Confiar-se em alguém, ter confiança; estar seguro.",
    "u": "Usado 120 vezes na AT. Confiança no Eterno.",
    "e": "Raiz primária"
  },
  "H3820": {
    "m": "coração, espírito",
    "d": "Coração, sede das emoções; espírito, inteligência, vontade.",
    "u": "Usado 598 vezes na AT. O coração do homem.",
    "e": "Raiz primária"
  },
  "H3068": {
    "m": "YHWH, o Eterno",
    "d": "O nome próprio de Deus, tetragrama sagrado YHWH.",
    "u": "Usado 6828 vezes na AT. O nome mais santo.",
    "e": "De הָיָה (hayah) = ser, existir"
  },
  "H160": {
    "m": "amor, afeto",
    "d": "Amor, afeto; ato de amor.",
    "u": "Usado 40 vezes na AT. O amor de Deus pelo seu povo.",
    "e": "De אָהַב (ahab) = amar"
  },
  "H5769": {
    "m": "eternidade, sempre",
    "d": "Tempo indefinido, eternidade; sempre, perpetuidade.",
    "u": "Usado 439 vezes na AT. O amor eterno de Deus.",
    "e": "De עָלַם (alam) = esconder, estar escondido"
  },
  "H2617": {
    "m": "bondade, misericórdia, fidelidade",
    "d": "Bondade, misericórdia ; fidelidade à aliança ; amor leal.",
    "u": "Utilizado 248 vezes na AT. A bondade do Senhor.",
    "e": "De חָסַד (chasad) = ser bom, misericordioso"
  },
  "G32": {
    "m": "anjo, mensageiro",
    "d": "Mensageiro ; anjo celestial ao serviço de Deus.",
    "u": "Utilizado 175 vezes no NT. Os anjos de Deus.",
    "e": "De ἀγγέλλω (aggello) = anunciar"
  },
  "G3735": {
    "m": "montanha, colina",
    "d": "Montanha, monte ; colina elevada.",
    "u": "Utilizado 63 vezes no NT. A montanha da transfiguração.",
    "e": "Provavelmente de ὁράω (horao) = ver"
  },
  "G2222": {
    "m": "vida",
    "d": "Vida física ou espiritual ; a vida eterna em Deus.",
    "u": "Utilizado 135 vezes no NT. Jesus é a vida.",
    "e": "De ζάω (zao) = viver"
  },
  "G649": {
    "m": "enviar, delegar",
    "d": "Enviar com uma missão ; delegar como embaixador.",
    "u": "Utilizado 132 vezes no NT. O Pai envia o Filho.",
    "e": "De ἀπό (apo) = de + στέλλω (stello) = enviar"
  },
  "G2919": {
    "m": "julgar, decidir",
    "d": "Julgar, pronunciar um julgamento ; decidir, determinar.",
    "u": "Utilizado 114 vezes no NT. Deus julga o mundo.",
    "e": "Raiz primária"
  },
  "G4982": {
    "m": "salvar, libertar",
    "d": "Salvar de perigo ou destruição ; libertar do pecado.",
    "u": "Utilizado 106 vezes no NT. Jesus salva os pecadores.",
    "e": "De σῶς (sos) = sadio e seguro"
  },
  "G3686": {
    "m": "nome",
    "d": "Nome, título ; reputação ; autoridade, poder.",
    "u": "Utilizado 228 vezes no NT. O nome de Jesus.",
    "e": "Raiz primária"
  },
  "G3439": {
    "m": "único, único engendrado",
    "d": "Único em seu gênero, único engendrado ; filho único.",
    "u": "Utilizado 9 vezes no NT. O Filho Único de Deus.",
    "e": "De μόνος (monos) = sozinho + γίνομαι (ginomai) = tornar-se"
  },
  "G622": {
    "m": "perder, destruir, perecer",
    "d": "Destruir completamente ; perder, perecer ; ser arruinado.",
    "u": "Utilizado 90 vezes no NT. Salvar o que estava perdido.",
    "e": "De ἀπό (apo) = de + ὄλλυμι (ollumi) = destruir"
  },
  "H430": {
    "m": "Deus, deuses",
    "d": "O Deus supremo (Elohim); às vezes usado para juízes ou deuses pagãos.",
    "u": "Usado 2606 vezes na AT. Nome plural de majestade para Deus.",
    "e": "Plural de אֱלוֹהַּ (eloah) = deus"
  },
  "H1254": {
    "m": "criar",
    "d": "Criar do nada; formar, fazer; atividade exclusiva de Deus.",
    "u": "Usado 54 vezes na AT. Deus criou os céus e a terra.",
    "e": "Raiz primária"
  },
  "H776": {
    "m": "terra, país",
    "d": "Terra, solo; país, região; o mundo terrestre.",
    "u": "Usado 2504 vezes na AT. A terra que Deus criou.",
    "e": "Raiz primária"
  },
  "H8414": {
    "m": "informe, vazio, caos",
    "d": "Deserto, desolação; caos, vazio, nada.",
    "u": "Usado 20 vezes na AT. A terra estava informe e vazia.",
    "e": "De תָּהָה (tahah) = errar"
  },
  "H7307": {
    "m": "espírito, sopro, vento",
    "d": "Sopro, vento; espírito de Deus ou do homem; disposição mental.",
    "u": "Usado 378 vezes na AT. O Espírito de Deus.",
    "e": "De רוּחַ (ruach) = soprar"
  },
  "H559": {
    "m": "dizer, falar",
    "d": "Dizer, falar, declarar ; ordenar, pensar.",
    "u": "Utilizado 5316 vezes na AT. O verbo de palavra mais frequente.",
    "e": "Raiz primária"
  },
  "H7200": {
    "m": "ver, olhar",
    "d": "Ver com os olhos ; perceber, compreender ; providenciar.",
    "u": "Utilizado 1311 vezes na AT. Deus viu que era bom.",
    "e": "Raiz primária"
  },
  "H2896": {
    "m": "bom, bem",
    "d": "Bom, agradável, excelente ; benevolente, justo.",
    "u": "Utilizado 559 vezes na AT. Deus viu que era bom.",
    "e": "Raiz primária"
  },
  "H7121": {
    "m": "chamar, gritar, proclamar",
    "d": "Chamar, gritar ; nomear ; proclamar, convocar.",
    "u": "Utilizado 736 vezes na AT. Chamar o nome do Eterno.",
    "e": "Raiz primária"
  },
  "H3117": {
    "m": "dia",
    "d": "Dia (em contraste com a noite) ; período de 24 horas ; época, tempo.",
    "u": "Utilizado 2301 vezes na AT. O dia que o Senhor fez.",
    "e": "De יוֹם (yowm) = estar quente"
  },
  "H3915": {
    "m": "noite",
    "d": "Noite (oposta ao dia) ; tempo de escuridão.",
    "u": "Usado 234 vezes na AT. Deus separou o dia e a noite.",
    "e": "Raiz primária"
  },
  "G2531": {
    "m": "como, segundo que",
    "d": "Como, da mesma maneira que ; segundo que, na medida em que.",
    "u": "Usado 182 vezes no NT. Conjunção comparativa.",
    "e": "De κατά (kata) = conforme + ὡς (hos) = como"
  },
  "G3475": {
    "m": "Moisés",
    "d": "Moisés, o legislador de Israel.",
    "u": "Usado 80 vezes no NT. A lei de Moisés.",
    "e": "Do hebraico מֹשֶׁה (Mosheh) = tirado (das águas)"
  },
  "G5312": {
    "m": "elevar, exaltar",
    "d": "Levantar para cima, elevar ; exaltar, honrar.",
    "u": "Usado 20 vezes no NT. O Filho do homem elevado.",
    "e": "De ὕψος (hupsos) = altura"
  },
  "G3789": {
    "m": "serpente",
    "d": "Serpente, réptil ; a serpente antiga (Satanás).",
    "u": "Usado 14 vezes no NT. A serpente de bronze no deserto.",
    "e": "Raiz primária"
  },
  "G2048": {
    "m": "deserto, solitário",
    "d": "Lugar deserto, wilderness ; solitário, despovoado.",
    "u": "Utilizado 48 vezes no NT. Os 40 dias de Jesus no deserto.",
    "e": "De ἔρημος (eremos) = abandonado"
  },
  "G3956": {
    "m": "tudo, cada",
    "d": "Tudo, cada um, todos ; o conjunto, a totalidade.",
    "u": "Utilizado 1244 vezes no NT. Entre os palavras mais frequentes.",
    "e": "Raiz primária"
  },
  "G4100": {
    "m": "crer, ter fé",
    "d": "Ter fé em, crer ; confiar em, apoiar-se em.",
    "u": "Utilizado 241 vezes no NT. Crer em Jesus para ser salvo.",
    "e": "De πίστις (pistis) = fé"
  },
  "H7549": {
    "m": "extensão, firmamento",
    "d": "Extensão, arco celestial, firmamento ; o céu.",
    "u": "Utilizado 17 vezes na AT. A extensão no meio das águas.",
    "e": "De רָקַע (raqa) = estender, bater"
  },
  "H4325": {
    "m": "água, águas",
    "d": "Água, águas ; chuva ; fluxo, mar.",
    "u": "Utilizado 585 vezes na AT. As águas da criação.",
    "e": "Dual de מַיִם (mayim) = água"
  },
  "H6213": {
    "m": "fazer, realizar",
    "d": "Fazer, fabricar, realizar ; agir, trabalhar.",
    "u": "Utilizado 2632 vezes na AT. Verbo muito frequente.",
    "e": "Raiz primária"
  },
  "H8064": {
    "m": "céus, céu",
    "d": "Céus, firmamento ; morada de Deus ; céu visível.",
    "u": "Utilizado 420 vezes na AT. Os céus e a terra.",
    "e": "Dual de שָׁמַיִם (shamayim) = alturas"
  },
  "H120": {
    "m": "homem, humanidade, Adão",
    "d": "Homem, ser humano ; a humanidade ; Adão o primeiro homem.",
    "u": "Utilizado 562 vezes na AT. Deus criou o homem.",
    "e": "De אָדֹם (adom) = vermelho, ou אֲדָמָה (adamah) = terra"
  },
  "H6754": {
    "m": "imagem, semelhança",
    "d": "Imagem, semelhança ; forma, aparência.",
    "u": "Utilizado 17 vezes na AT. O homem criado à imagem de Deus.",
    "e": "De צָלַל (tsalal) = sombrear, parecer-se"
  },
  "H3966": {
    "m": "muito, extremamente",
    "d": "Muito, extremamente, muito ; com força, rapidamente.",
    "u": "Utilizado 300 vezes na AT. Isso era muito bom.",
    "e": "De מָאַד (ma'ad) = ser numeroso"
  },
  "H7257": {
    "m": "deitar-se, repousar",
    "d": "Deitar-se, repousar ; permanecer ; incubar.",
    "u": "Usado 30 vezes na AT. Ele me faz repousar (Sl 23:2).",
    "e": "Raiz primária"
  },
  "H4999": {
    "m": "pastagem, morada",
    "d": "Local de pastagem, pradaria ; habitação, morada.",
    "u": "Usado 13 vezes na AT. Em verdes pastagens.",
    "e": "De נָאָה (na'ah) = ser belo, apropriado"
  },
  "H5148": {
    "m": "conduzir, guiar",
    "d": "Conduzir, guiar, dirigir ; levar em segurança.",
    "u": "Usado 40 vezes na AT. Ele me conduz (Sl 23:3).",
    "e": "Raiz primária"
  },
  "H7725": {
    "m": "voltar-se, retornar, restaurar",
    "d": "Voltar-se, retornar ; restaurar, renovar ; arrepender-se.",
    "u": "Usado 1058 vezes na AT. Restaurar minha alma.",
    "e": "Raiz primária"
  },
  "H5315": {
    "m": "alma, vida, pessoa",
    "d": "Alma, vida, ser vivo ; pessoa, eu mesmo ; desejo, apetite.",
    "u": "Usado 753 vezes na AT. Minha alma, minha vida.",
    "e": "De נָפַשׁ (naphash) = respirar"
  },
  "H6664": {
    "m": "justiça, retidão",
    "d": "Justiça, retidão, equidade ; fidelidade.",
    "u": "Utilizado 119 vezes na AT. Caminhos da justiça.",
    "e": "De צָדַק (tsadaq) = ser justo"
  },
  "H1980": {
    "m": "caminhar, ir",
    "d": "Caminhar, ir, vir ; viver, se comportar.",
    "u": "Utilizado 1554 vezes na AT. Verbo de movimento muito frequente.",
    "e": "Raiz primária"
  },
  "H1516": {
    "m": "vale, ravina",
    "d": "Vale, garganta, ravina ; planície.",
    "u": "Utilizado 60 vezes na AT. O vale da sombra da morte.",
    "e": "Raiz primária"
  },
  "H6757": {
    "m": "sombra da morte, escuridão profunda",
    "d": "Escuridão profunda, obscuridade mortal ; sombra da morte.",
    "u": "Utilizado 18 vezes na AT. Simboliza o perigo extremo.",
    "e": "De צֵל (tsel) = sombra + מָוֶת (maveth) = mort"
  },
  "H3372": {
    "m": "temer, ter medo, reverenciar",
    "d": "Temer, ter medo ; reverenciar, respeitar Deus.",
    "u": "Utilizado 335 vezes na AT. Não temo nenhum mal.",
    "e": "Raiz primária"
  },
  "H7626": {
    "m": "bastão, tribo",
    "d": "Bastão, verga ; tribo, ramo familiar.",
    "u": "Utilizado 190 vezes na AT. Teu bastão e tua verga.",
    "e": "De שָׁבַט (shabat) = ramificar"
  },
  "H1004": {
    "m": "casa, morada",
    "d": "Casa, habitação ; família, parentela ; templo.",
    "u": "Utilizado 2055 vezes na AT. A casa do Senhor.",
    "e": "De בָּנָה (banah) = construir"
  },
  "H6186": {
    "m": "arranjar, dispor",
    "d": "Arranjar em ordem, dispor ; preparar uma mesa.",
    "u": "Utilizado 75 vezes na AT. Tu arrumas a mesa (Sl 23:5).",
    "e": "Raiz primária"
  },
  "H7979": {
    "m": "mesa",
    "d": "Mesa para comer ; mesa dos pães da proposição.",
    "u": "Utilizado 71 vezes na AT. A mesa preparada.",
    "e": "De שָׁלַח (shalach) = enviar, estender"
  },
  "H6887": {
    "m": "estar em apuros, adversário",
    "d": "Estar apertado, em apuros ; adversário, inimigo.",
    "u": "Utilizado 58 vezes na AT. Diante dos meus adversários.",
    "e": "Raiz primária"
  },
  "H1878": {
    "m": "engordar, tornar gordo",
    "d": "Tornar gordo, engordar ; prosperar.",
    "u": "Usado 11 vezes na AT. Unjas minha cabeça com óleo.",
    "e": "De דֶּשֶׁן (deshen) = gordura, cinzas"
  },
  "H3563": {
    "m": "copo, calice",
    "d": "Copo, calice ; porção, sorte.",
    "u": "Usado 31 vezes na AT. Meu copo transborda.",
    "e": "Raiz primitiva"
  },
  "H7291": {
    "m": "perseguir, expulsar",
    "d": "Perseguir, expulsar ; perseguir ; seguir de perto.",
    "u": "Usado 144 vezes na AT. A bondade me perseguirá.",
    "e": "Raiz primitiva"
  }
};
